














import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwBlockingProgress } from '@libs-uuif/shared/sw-blocking-progress';
import { State } from 'vuex-class';
import { RootStoreState } from '@/store';
import { SwApp } from '@sonicwall/unified-ui-framework/src/shared/sw-app';

@Component({
  components: {
    SwBlockingProgress,
    SwApp,
  },
})
export default class MswSpogMain extends SwExtendedVue {
  @State((state: RootStoreState) => state.CoreStoreModule.loading)
  visible:boolean;
}
